import { Component, OnInit, Input } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

import 'moment/locale/pt-br';

// Service
import { CockpitService } from '../../../service/cockpit/cockpit.service';

@Component({
	selector: 'app-allowance-proposal',
	templateUrl: './allowance-proposal.component.html',
	providers: [
		CockpitService,
		HttpModule
	]
})
export class CockpitAllowanceProposalComponent implements OnInit {

	@Input('follow') follow: boolean;

	public userAllowanceProposal: any[] = [];
	public orderby: string = "NumeroProposta";
	public sort: string = "asc";

	constructor(private CockpitService: CockpitService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
	}

	ngOnInit() {
		this.getUserAllowanceProposal();
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getUserAllowanceProposal();
	}

	getUserAllowanceProposal() {
		this.CockpitService.getUserAllowanceProposal(this.follow, this.orderby, this.sort).subscribe(result => {
			if (result.Success) {
				this.userAllowanceProposal = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/allowance-proposal/allowance-proposal.component.ts